import React from 'react';

import styled from '@emotion/styled';

import ChartWrapper from '../../../components/Charts/ChartWrapper';
import PieChart from '../../../components/Charts/PieChart';

const FeedbackDistribution = () => {
  const feedbackDistributionDataStats = [
    { name: 'Positive feedback', value: 2, color: '#5B91F5' },
    { name: 'Negative feedback', value: 6, color: '#CFDFFC' },
  ];

  return (
    <PieChartArea>
      {/* Pie chart 1 */}
      <ChartWrapper label='Route Analysis Chart' maxWidth='100%' radius='8px'>
        <ChartRow>
          <PieArea>
            <PieChart
              data={feedbackDistributionDataStats}
              aspect={1}
              outerRadius={96}
              cx='50%'
              cy='50%'
              showLabels={false}
              showLegend={false}
              tooltipValueFormatter={(value) => `${value}`}
            />
          </PieArea>
          <LegendArea>
            {feedbackDistributionDataStats.map((item) => (
              <LegendRow key={item.name}>
                <LegendLabelBlock>
                  <LegendDot color={item.color ?? '#5B91F5'} />
                  <LegendText>{item.name}</LegendText>
                </LegendLabelBlock>
                <LegendValue>{item.value}</LegendValue>
              </LegendRow>
            ))}
          </LegendArea>
        </ChartRow>
      </ChartWrapper>
    </PieChartArea>
  );
};

export default FeedbackDistribution;

const PieChartArea = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;

  @media (max-width: 884px) {
    grid-template-columns: 1fr;
    /* justify-items: center;
    gap: 14px; */
  }
`;

const ChartRow = styled.div`
  height: 100%;
  display: grid;
  grid-template-columns: minmax(190px, 260px) 1fr;
  align-items: center;
  gap: 24px;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
    justify-items: center;
    gap: 14px;
  }
`;

const LegendArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 100%;
`;

const PieArea = styled.div`
  width: 100%;
  max-width: 240px;
  min-width: 220px;
  margin: 0 auto;
`;

const LegendRow = styled.div`
  display: grid;
  grid-template-columns: 144px auto;
  gap: 16px;
`;

const LegendLabelBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const LegendDot = styled.span<{ color: string }>`
  width: 10px;
  height: 10px;
  border-radius: 3px;
  background-color: ${({ color }) => color};
  flex-shrink: 0;
`;

const LegendText = styled.span`
  font-size: 14px;
  line-height: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.neutralGray};
`;

const LegendValue = styled.span`
  font-size: 14px;
  line-height: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.logirateBlack};
`;
